import React, { FC } from "react";
import { toast } from "react-toastify";
import ButtonComponent from "../../buttons/ButtonComponent";

interface PopupModuleActionsProps {
  isMutated: boolean;
  canDelete: boolean;
  onSave: () => void;
  onDelete: () => void;
}

export const PopupModuleActions: FC<PopupModuleActionsProps> = ({
  isMutated,
  canDelete,
  onSave,
  onDelete,
}) => {
  return (
    <div className="popup_module_btnblock">
      <ButtonComponent
        onClick={() => (isMutated ? onSave() : toast.error("нет изменений"))}
        title="сохранить"
      />
      {canDelete ? (
        <ButtonComponent
          onClick={onDelete}
          type="del"
          title="удалить"
        />
      ) : null}
    </div>
  );
};
